import React from 'react'
import {defineMessages, FormattedMessage} from 'react-intl'
import {CouponType, PublicViewCategory, StationType, BusinessType, BadgeType} from '../../config/constants'
import {II18nMessage} from '../../reducers/i18n'
import styles from './TypeLabel.scss'
import superHolder from '../../assets/imgs/cars/super-holder.png'
import ResponsiveImg from './ResponsiveImg'

export const thumbnailLabelMessages: {[key in PublicViewCategory | CouponType | BusinessType | StationType | BadgeType ]: II18nMessage} = defineMessages({
  [PublicViewCategory.rvpark]: {
    id: 'thumbnailLabel.rvpark',
    defaultMessage: 'RV-Park'
  },
  [PublicViewCategory.nature]: {
    id: 'thumbnailLabel.nature',
    defaultMessage: 'Spot'
  },
  [PublicViewCategory.relaxation]: {
    id: 'thumbnailLabel.relaxation',
    defaultMessage: 'Onsen'
  },
  [PublicViewCategory.historical]: {
    id: 'thumbnailLabel.historical',
    defaultMessage: 'History'
  },
  [CouponType.parking]: {
    id: 'thumbnailLabel.parking',
    defaultMessage: 'Parking'
  },
  [CouponType.camping]: {
    id: 'thumbnailLabel.camping',
    defaultMessage: 'Camping'
  },
  [CouponType.activity]: {
    id: 'thumbnailLabel.activity',
    defaultMessage: 'Activity'
  },
  [CouponType.car]: {
    id: 'thumbnailLabel.car',
    defaultMessage: 'Car'
  },
  [BusinessType.personal]: {
    id: 'thumbnailLabel.personal',
    defaultMessage: 'Shared'
  },
  [BusinessType.business]: {
    id: 'thumbnailLabel.business',
    defaultMessage: 'Rental'
  },
  [BadgeType.superholder]: {
    id: 'thumbnailLabel.superholder',
    defaultMessage: 'Super holder'
  },
})

const TypeLabel = ({type}: {type: PublicViewCategory | StationType | BusinessType | BadgeType}) => <div
  className={[
    styles.typeLabel,
    styles[type]
  ].join(' ')}>
  <div className="d-flex justify-content-center align-items-center">
    {type === BadgeType.superholder && <ResponsiveImg
        noLazy
        className={['mr-1', styles.superHolderIcon].join(' ')}
        caption="Profile"
        url={superHolder}
        />}
    <FormattedMessage {...thumbnailLabelMessages[type]}/>
  </div>
</div>
TypeLabel.displayName = 'TypeLabel'
export default TypeLabel
